import { Reveal } from "./Reveal";
import { useLanguage } from "@/context/LanguageContext";

export default function Stories() {
  const { t } = useLanguage();

  const STORIES = [
    { quote: t("stories.s1q"), name: "Mateo R.", detail: t("stories.s1d") },
    { quote: t("stories.s2q"), name: "Sofia L.", detail: t("stories.s2d") },
    { quote: t("stories.s3q"), name: "Daniel K.", detail: t("stories.s3d") },
  ];

  return (
    <section id="stories" className="border-y border-white/10 bg-surface/50 py-24 md:py-40" data-testid="stories-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-jetbrains text-xs uppercase tracking-[0.35em] text-volt mb-6">{t("stories.chapter")}</p>
          <h2 className="font-cabinet font-black uppercase text-4xl md:text-6xl leading-[0.95] tracking-tight mb-16 md:mb-24">
            {t("stories.h2a")}<span className="text-outline">{t("stories.h2b")}</span>
          </h2>
        </Reveal>

        <div className="space-y-20 md:space-y-28">
          {STORIES.map((s, i) => (
            <Reveal key={s.name} delay={0.05} className={`max-w-4xl ${i % 2 === 1 ? "md:ml-auto" : ""}`}>
              <blockquote data-testid={`story-quote-${i}`}>
                <p className="font-playfair italic text-2xl md:text-4xl lg:text-5xl leading-snug text-white/90">
                  "{s.quote}"
                </p>
                <footer className="mt-8 flex items-center gap-4">
                  <span className="h-px w-12 bg-volt" aria-hidden="true" />
                  <div>
                    <p className="font-cabinet font-bold uppercase tracking-wide">{s.name}</p>
                    <p className="font-jetbrains text-xs uppercase tracking-[0.25em] text-white/40 mt-1">{s.detail}</p>
                  </div>
                </footer>
              </blockquote>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
